import $ from 'jquery';

$(function () {
    $('form.product-main__form').submit(function (event) {
        let $form = $(this);
        let buttonElement = $form.children('.product-main__form-submit:first');
        let goToCart = $form.children('.product-main__added-to-cart-container');
        $.ajax({
            type: 'POST',
            async: true,
            url: '/cart/add',
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function () {
                // $form.addClass('sending');
            },
            error: function (data) {
                buttonElement.text(data.responseJSON.errors);
                buttonElement.attr('disabled', true);
                setTimeout(() => {
                    buttonElement.text('dodaj v kosarico');
                    buttonElement.attr('disabled', false);
                }, 1500);
            },
            success: function () {
                $.getJSON('/cart.js', function (cart) {
                    let cartElement = document.getElementsByClassName('header__menu--purple-span')[0];
                    cartElement.innerHTML = '(' + cart.item_count + ')';
                    cartElement.classList.remove('disabled');
                });
                buttonElement.html('Dodano V Košarico');
                buttonElement.attr('disabled', true);
                goToCart.fadeIn(300);
                setTimeout(() => {
                    buttonElement.text('dodaj v kosarico');
                    buttonElement.attr('disabled', false);
                }, 1500);
            }
        });
        event.preventDefault();
    });
});
